import React from "react";
import "./Skill.css";
const Skill = () => {
  return (
    <>
      <div className="skill-text" data-aos="fade-right"></div>

      <div className="skills">
        <div className="skills-share">
          <ul>
            <li>React</li>
            <li>React Redux</li>
            <li>Node.js</li>
          </ul>
          <ul className="margin-top">
            <li>Firebase Authentication</li>
            <li>Heroku</li>
            <li>Git / Github</li>
          </ul>
        </div>
        <div className="skills-share">
          <ul>
            <li>Responsive Design</li>
            <li>State management</li>
            <li>backend work</li>
          </ul>
          <ul className="margin-top">
            <li>auth & hosting</li>
            <li>frontend & backend hosting</li>
            <li>File store</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Skill;
